/* eslint-disable */

import React from 'react';

import * as dataInterface from '../shared/interfaces';
import * as utils from '../shared/utils';
import { Book, CartListItem } from '../shared/interfaces';

const Context: dataInterface.AppContextType = {
  cart: { cartItems: [] },
  setCart: (value: dataInterface.Cart<dataInterface.Book>) => {
    return value;
  },
  addToCart: (book: dataInterface.Book) => {
    return book;
  },
  removeFromCart: (book: dataInterface.Book) => {
    return book;
  },
  setQuantity: (book: dataInterface.Book, quantity: number) => {
    return book;
  },
};

const AppContext = React.createContext<dataInterface.AppContextType>(Context);

const actions = {
  SET_CART: 'SET_CART',
  ADD_TO_CART: 'ADD_TO_CART',
  SET_QUANTITY: 'SET_QUANTITY',
  REMOVE_FROM_CART: 'REMOVE_FROM_CART',
};

const addToCart = (bookCart: Book, state: any) => {
  const { cart } = state;
  const existedBook = utils.contextContainsProduct(cart, bookCart);
  if (!existedBook) {
    cart.cartItems.push({ product: bookCart, quantity: 1 });
  }
  return bookCart;
};

const setQuantity = (bookCart: any, state: any) => {
  const { cart } = state;
  const { book, quantity } = bookCart;

  const productIndex = utils.findIndexOfProduct(cart, book);

  if (quantity <= 0) {
    // Remove item if quantity is zero or less
    cart.cartItems = cart.cartItems.filter(
      (item: CartListItem<Book>) => item.product.id !== book.id,
    );
  } else if (productIndex !== -1) {
    // Update quantity if item exists
    cart.cartItems[productIndex].quantity = quantity;
  } else {
    // Add item if it doesn't exist
    cart.cartItems.push({ product: book, quantity });
  }

  return bookCart;
};

const removeFromCart = (bookCart: Book, state: any) => {
  const { cart } = state;
  cart.cartItems = cart.cartItems.filter(
    (item: CartListItem<Book>) => item.product.id !== bookCart.id,
  );
  return bookCart;
};

const reducer = (state: any, action: dataInterface.StateAction) => {
  switch (action.type) {
    case actions.SET_CART: {
      return { ...state, cart: action.value };
    }
    case actions.ADD_TO_CART: {
      // @ts-expect-error Reason for suppressing this
      addToCart(action.value, state);
      return { ...state };
    }
    case actions.SET_QUANTITY: {
      setQuantity(action.value, state);
      return { ...state };
    }
    case actions.REMOVE_FROM_CART: {
      // @ts-expect-error Reason for suppressing this
      removeFromCart(action.value, state);
      return { ...state };
    }
    default:
      return state;
  }
};

const AppProvider = ({ children }: dataInterface.AppProviderType) => {
  const [state, dispatch] = React.useReducer(reducer, Context);

  const contextValue = {
    ...state,
    cart: state.cart,
    setCart: (data: any) => {
      dispatch({ type: actions.SET_CART, value: data });
    },
    addToCart: (book: dataInterface.Book) => {
      dispatch({ type: actions.ADD_TO_CART, value: book });
    },
    removeFromCart: (book: dataInterface.Book) => {
      dispatch({ type: actions.REMOVE_FROM_CART, value: book });
    },
    setQuantity: (book: dataInterface.Book, quantity: number) => {
      dispatch({ type: actions.SET_QUANTITY, value: { book, quantity } });
    },
  };

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};

export { AppContext, AppProvider };
